import { Component, Input, OnInit } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'
import { AppSettingService, LabsService } from '../../../../../api/services'
import { DataPageOfLab } from '../../../../../api/models'
import { SafeHtml, DomSanitizer } from '@angular/platform-browser'
import { CareFinitySession } from '../../../../services/CareFinitySession'

@Component({
  selector: 'app-lab-details',
  templateUrl: './lab-details.component.html',
  styleUrls: ['./lab-details.component.css'],
})
export class LabDetailsComponent implements OnInit {
  //testName: string;
  //obrid: string;
  labdetails: DataPageOfLab
  public cols: any[]
  patientnote: SafeHtml
  displaypopup: boolean = false
  rows: number
  comments: string = ''

  @Input() testName: string
  @Input() obrid: string
    showPatientDemographicPrint: boolean = false

    
    setPrintFlag: boolean = false;
  constructor(
    private labservice: LabsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
      protected sanitizer: DomSanitizer,
      private appSetting: AppSettingService,
  ) {}

  ngOnInit() {
    debugger
    //this.activatedRoute.queryParams.subscribe(params => {
    //    let data = params;
    //    this.testName = data.TestName;
    //    this.obrid = data.OBRID;
    //});
      this.appSetting
          .appSettingGetPracticeSettings$Response()
          .subscribe((res) => {
              this.showPatientDemographicPrint = res.body.enablePatientDemographicPrint;
              if (CareFinitySession?.user.roles.patientRecordsPrint == true && this.showPatientDemographicPrint == true) {
                  this.setPrintFlag = true;
              }
              else {
                  this.setPrintFlag = false;
              }
          })
    this.cols = [
      { field: 'obxSeqNumber', header: 'Seq No' },
      { field: 'observationValue', header: 'Observation Value' },
      { field: 'units', header: 'units' },
      { field: 'referenceRange', header: 'Reference Range' },
      { field: 'abnorFlags', header: 'Flag' },
      { field: 'signedoff', header: 'Signed Off' },
      { field: 'comment', header: 'Comment' },
    ]
    this.loadlabdetails(1, 'Desc')
    this.onViewComments()
  }
  loadlabdetails(pageNumber: number, sortbydirection: string) {
    this.labservice
      .labsDetail({
        patientId: sessionStorage.getItem('ptId'),
        emrpracticeId: localStorage.getItem('EmrPracticeId'),
        page: pageNumber,
        TestName: this.testName,
        OBRID: this.obrid,
      })
      .subscribe((result) => {
        console.log(result)

        this.labdetails = result

        this.rows = this.labdetails.pageSize
      })
  }
  gotoback() {
    this.router.navigate(['Patient/labs/list'])
  }
  onViewComments() {
    this.displaypopup = true
    this.labservice
      .labsViewCommnets({
        patientId: sessionStorage.getItem('ptId'),
        emrpracticeId: localStorage.getItem('EmrPracticeId'),
        OBRID: this.obrid,
      })
      .subscribe((result) => {
        /*this.patientnote = this.sanitizer.bypassSecurityTrustHtml(result.comment);*/
        this.comments = result.comment
      })
    }



    printLabComments() {
        var PrintLabs = document.getElementById('PrintLabComments_List') as HTMLElement
        const printWindow = window.open('', '_blank')
        if (printWindow) {
            const divContent = PrintLabs.innerHTML
            printWindow.document.open()
            printWindow.document.write('<html><head><title>Print::Labs Details and Comments</title>')
            // Adding CSS styling for alternate rows
            printWindow.document.write('<style type="text/css">')
            printWindow.document.write(
                '    #Labs_print_table_tbody tbody tr:nth-child(odd) {',
            )
            printWindow.document.write('        background-color: #f2f2f2;')
            printWindow.document.write('    }')
            printWindow.document.write(
                '    #Labs_print_table_tbody tbody tr:nth-child(even) {',
            )
            printWindow.document.write('        background-color: #e6e6e6;')
            printWindow.document.write('    }')
            printWindow.document.write('</style>')
            printWindow.document.write('</head><body>')
            printWindow.document.write(divContent)
            printWindow.document.write('</body><html>')
            printWindow.document.close()
            printWindow.focus()
            printWindow.print()
            printWindow.close()
        } else {
            console.error('Failed to open print window.')
        }
    }

}
